import Vue from 'vue'

import CarCard from '@/components/Generals/CarCard';
Vue.component('CarCard', CarCard);

import CarGroupCard from '@/components/Generals/CarGroupCard';
Vue.component('CarGroupCard', CarGroupCard);

import Footer from '@/components/Generals/Footer';
Vue.component('Footer', Footer);

import Modal from '@/components/Generals/Modal';
Vue.component('Modal', Modal);

import Navigation from '@/components/Generals/Navigation';
Vue.component('Navigation', Navigation);

import Title from '@/components/Generals/Title';
Vue.component('Title', Title);

import NoticeCard from '@/components/Generals/NoticeCard';
Vue.component('NoticeCard', NoticeCard);

import OwlCarousel from '@/components/Generals/OwlCarousel';
Vue.component('OwlCarousel', OwlCarousel);




// WEBPACK FOOTER //
// ./src/components/Generals/index.js